export var DocumentTypes;
(function (DocumentTypes) {
    DocumentTypes[DocumentTypes["FILE"] = 0] = "FILE";
    DocumentTypes[DocumentTypes["PICTURE_GALLERY"] = 1] = "PICTURE_GALLERY";
    DocumentTypes[DocumentTypes["CAMERA"] = 2] = "CAMERA";
})(DocumentTypes || (DocumentTypes = {}));
